import React from 'react';
import cn from 'classnames';

import { isMobile } from 'app-constants';
import { FixedOverlay } from 'components';
import { AsyncQuickBetslip } from 'modules/betslip/async';
import SidebarTogglerDesk, { SidebarTogglerMob } from '../SidebarToggler';
import './footer.scss';

const SidebarToggler = isMobile ? SidebarTogglerMob : SidebarTogglerDesk;

interface Props {}

const Footer: React.FC<Props> = () => (
    <FixedOverlay>
        <div
            styleName={cn('container', {
                'is-mobile': isMobile,
            })}
        >
            <SidebarToggler />
            {isMobile && <AsyncQuickBetslip />}
        </div>
    </FixedOverlay>
);

export default Footer;
